<template>

  <v-select label="name"
    v-model="selectedValue"
    :options="options"
    :reduce="option => option.document_id"
    :placeholder="placeholder">
    <template slot="no-options">
      {{ placeholder }}
    </template>
    <template slot="option" slot-scope="option">
      <div class="d-center">
        <img :src="option.file.thumbnail || asset('public' + fallbackImage)"/>
        {{ option.name }}
        </div>
    </template>
    <template slot="selected-option" slot-scope="option">
      <div class="selected d-center">
        <img :src='option.file.thumbnail'/>
        {{ option.name }}
      </div>
    </template>
  </v-select>

</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css';

export default {
  name: "select-resource-from-activity-modal",

  components: {
    vSelect
  },

  props: {
    value: {
      type: [String, Number, null],
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'image' // o 'drawing'
    },
    fallbackImage: {
      type: String,
      default: '/img_placeholder.png'
    }
  },

  data() {
    return {
      processingData: false,
      isModalActive: false,
      isLoading: false,

      selectedResource: null,
      resourcesList: [],
    }
  },

  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
        this.$emit('change', newValue);

        const selected = this.options.find(opt => opt.document_id === newValue);
        this.$emit('selected-object', selected || null);
      }
    },

    placeholder() {
      if (this.type === 'drawing') {
        return this.options.length > 0 ? this.$t('select_drawing') : this.$t('no_drawings');
      }
      return this.options.length > 0 ? this.$t('select_image') : this.$t('no_images');
    }
  },

  created() {

  },

  methods: {
  }
}
</script>

<style scoped>
  img {
    height: auto;
    max-width: 2.5rem;
    margin-right: 1rem;
  }

  .d-center {
    display: flex;
    align-items: center;
  }

  .selected img {
    width: auto;
    max-height: 23px;
    margin-right: 0.5rem;
  }

  .v-select .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
  }

  .v-select .dropdown li:last-child {
    border-bottom: none;
  }

  .v-select .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
  }

  .v-select .dropdown-menu .active > a {
    color: #fff;
  }

</style>